<form-popup
    titleText="User Password Update"
    saveText="Confirm"
    [width]="520"
    [visible]="visible"
    [isSaveDisabled]="isSaving"
    (open)="reset()"
    (save)="confirm()"
    (visibleChange)="onVisibleChange($event)"
>
    <div class="pb-3">
        <label class="form-label">Password*:</label>
        <dx-text-box [(value)]="password" [maxLength]="100" stylingMode="filled">
            <dx-validator>
                <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
</form-popup>
